import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';

import PageContainer from 'components/PageContainer';
import Header from 'components/Header';
import Stepper from 'components/Stepper';
import Sidebar from 'components/Sidebar';
import SignUp, { getSignUpSteps } from 'containers/SignUp';
import Footer from 'components/Footer';
import type { VerifyAccountDto } from 'state/signUpSteps/signUpStepsTypes';
import type { Errors } from 'state/shared';

import useStyles from './SignUpPage.style';

type SignUpPageProps = {
  currentStep: number;
  isValid: boolean;
  pending: boolean;
  errors: Errors;
  updateValidation: (isValid: boolean) => void;
  verifyAccount: (verifyAccountDto: VerifyAccountDto) => void;
};

const firstChildTopSpacing = 5; // 40px

const SignUpPage: React.FC<SignUpPageProps> = (props) => {
  const { container, signUpFormContainer } = useStyles({
    firstChildTopSpacing,
  });
  const {
    currentStep,
    isValid,
    pending,
    errors,
    updateValidation,
    verifyAccount,
  } = props;
  const dispatch = useDispatch();

  // TODO: make sure this is performant (usememo, usecallback, etc)
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const verificationToken = params.get('verify');
  const encodedUsername = params.get('username');
  const username = encodedUsername && atob(encodedUsername);
  useEffect(() => {
    if (verificationToken && username) {
      verifyAccount({ verificationToken, username });
    }
  }, [verificationToken, verifyAccount, username]);

  return (
    <PageContainer>
      <Header />
      <Stepper
        currentStep={currentStep}
        stepsContainer={getSignUpSteps(dispatch)}
        nextDisabled={!isValid}
        pending={pending}
      />
      <Grid container className={container}>
        <Hidden smDown>
          <Grid item sm={3} container>
            <Sidebar firstChildTopSpacing={firstChildTopSpacing}>
              <>
                <Typography variant="body2" component="div" color="primary">
                  &quot;I LoveBitTitan MigrationWiz. I&apos;ve probably used the
                  solution to migrate more than one million mailboxes to Office
                  365. Throughout my 10-year career at Champion Solutions Group,
                  I&apos;ve used a lot of migration tools - probably all of them
                  - and I keep coming back to MigrationWiz again and
                  again.&quot;
                </Typography>
                <Typography variant="body2" component="div">
                  Jim Canfield
                  <br />
                  Director of Online Services | Champion Solutions Group
                </Typography>
              </>
            </Sidebar>
          </Grid>
        </Hidden>
        <Grid
          item
          sm={12}
          md={9}
          container
          direction="column"
          alignItems="center"
        >
          <Grid
            item
            container
            direction="column"
            className={signUpFormContainer}
          >
            <SignUp
              stepsContainer={getSignUpSteps(dispatch)}
              currentStep={currentStep}
              updateValidation={updateValidation}
              pending={pending}
              errors={errors}
            />
          </Grid>
          <Grid item>
            <Footer />
          </Grid>
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default SignUpPage;
